import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Customers from "@/pages/Customers";
import Business from "@/pages/Business";
import Discover from "@/pages/Discover";
import Rewards from "@/pages/Rewards";
import Restaurants from "@/pages/Restaurants";
import Enterprise from "@/pages/Enterprise";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import LegalDoc from "@/pages/LegalDoc";
import PortalLogin from "@/pages/portal/PortalLogin";
import PortalBilling from "@/pages/portal/PortalBilling";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/business" element={<Business />} />
              <Route path="/discover" element={<Discover />} />
              <Route path="/rewards" element={<Rewards />} />
              <Route path="/restaurants" element={<Restaurants />} />
              <Route path="/enterprise" element={<Enterprise />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/legal/:slug" element={<LegalDoc />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/business/login" element={<PortalLogin />} />
            <Route path="/business/billing" element={<PortalBilling />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </ThemeProvider>
  );
}

export default App;
